// Centralized app configuration
export const APP_CONFIG = {
  // Production domain - used for all external-facing URLs
  PRODUCTION_URL: "https://godyspo.com",
  
  // Supabase edge functions via custom domain (for social sharing/OG tags)
  SUPABASE_FUNCTIONS_URL: "https://share.godyspo.com/functions/v1",
  
  // Helper to get the correct base URL
  getBaseUrl: () => "https://godyspo.com"
};
